import { sessionStorage } from 'src/assets/js/storage';

//触发mutation的方法
const action = {
    mutationAction(context){
        context.commit('SET_USER');//执行mutation的方法SET_USER
    }
};

//触发action
// this.$store.dispatch('mutationAction')

export default action;


// WEBPACK FOOTER //
// ./src/store/action.js